const formControlLabelFormCreateUser = {
  admin: 'Administrator',
  analyst: 'Analyst',
  contractor: 'Third party company'
};

export default formControlLabelFormCreateUser;
